import { createAndMergeSliceReducer } from '@/utils/redux/create-and-merge-slice-reducer';
import { BannerDto } from '@/models/banner/banner.interface';

const sliceName = 'bannersSlice';

export interface BannersSliceType {
  isLoading: boolean;
  banners: BannerDto[];
}

export const initialState: BannersSliceType = {
  isLoading: false,
  banners: [],
};

export const bannersReducer = createAndMergeSliceReducer(sliceName, initialState);
